import React, { useEffect, useRef, useState } from "react";

import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";

import { makeStyles } from "@mui/styles";
import TotalAmountsTable from "../EntryTable.js/TotalAmountsTable";
import DeleteEntries from "../../../components/modals/DeleteEntries";
import DeleteNonItems from "../../../components/modals/DeleteNonItems";
import NewItemTable from "../EntryTable.js/NewItemTable";
import NewNonItemTable from "../EntryTable.js/NewNonItemTable";
import { useThemes } from "../../../components/Theme/theme";
import { useGetCompanyCodeTranslationQuery } from "../../../redux/apis/getCompanyCodeTranslation.api";
import { useStateList } from "./HandleInvoiceStateProvider";

function EntryTable({ Type, invoiceLabels, labelNamesOfTcs, labelNamesOfTds,params }) {
  const { theme } = useThemes();
  const {
    setInitialState,
    data,
    setData,

    accNames,
    setAccNames,
    expenceAccNames,
    viewMode,

    invoiceEntry,

    totTaxAmt,
    setTotTaxAmt,
    totDiscount,
    setTotDicount,
    totGSTCess,
    setTotGSTCess,
    totNetAmt,
    setTotNetAmt,
    totGST,
    setTotGST,
    totAmt,
    setTotAmt,
    companyState,

    itemID,
    setItemID,
    itemType,
    setItemType,
    openAddItemModal,
    setOpenAddItemModal,
    netAmountToPay,

    companyData,

    displayAllAccounts,
    setDisplayAllAccounts,

    setBackdropOpen,
    units,
    setunits,
    unitsObj,
    setUnitsObj,

    registrationType,

    itemValid,
    setItemValid,
    nonItemValid,
    setNonItemValid,
    isFocusItemRow,
    setIsFocusItemRow,
    isFocusNonItemRow,
    setIsNonItemFocusRow,
    partyType,

    setTableErrArr,
    itemCodes,
    setItemCodes,
    itemNames,
    setItemNames,
    items,
    setItems,
    nonItems,
    setNonItems,

    setInitItemTableDta,

    setInitNonItemTableData,

    setDeletedItems,

    setDeletedNonItems,
    originalInvoiceNos,
    setNetAmountToPay,
  } = useStateList();
  const useStyles = makeStyles({
    table: {
      "& .MuiTableCell-root": {
        border: "1px solid rgba(224, 224, 224, 1)",
        borderBottom: "2px solid rgba(224, 224, 224, 1)",
      },
    },
    newTableCell: {
      "& .MuiTableCell-root": {
        borderTop: "3px solid #9b6ab7 !important", // Top border
        borderBottom: "3px solid #9b6ab7", // Bottom border
        borderLeft: "3px solid #9b6ab7", // Left border
        borderRight: "3px solid #9b6ab7", // Right border
      },
    },

    errorTableCell: {
      border: "3px solid red !important",
    },
    stickyCell: {
      position: "sticky",
      right: 0,
      minWidth: "70px",
      backgroundColor: theme.palette.bodyGray.secondary,
      zIndex: 10, // Ensure the sticky cell appears above other cells
      boxShadow: "-5px 0 0 0 red", // Simulate a left border with shadow
      outline: "none",
      "&::before": {
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        bottom: 0,
        width: "1px", // Adjust this value for the desired border thickness
        backgroundColor: "rgba(224, 224, 224, 1)", // Border color
        zIndex: 11, // Ensure it appears above the cell content
        outline: "none",
      },
      "&:focus": {
        outline: "none", // This will remove the outline on focus
      },
    },
  });

  const classes = useStyles();

  const newItemObj = {
    itemCode: { label: "", value: "" },
    name: { label: "", value: "" },
    priceType: { label: "", value: 0},priceTypeArr:[],
    ledgerAccount: { label: "", value: "" },
    HSN: {
      label: "",
      value: "",
      companyID: "",
      hsnID: "",
      codeType: "",
      description: "",
    },
    qty: 0,
    units: "",
    rate: 0,
    amount: 0,
    dicount: 0,discountType:'Amount',discountRate:'',
    effectiveFrom: 0,
    effectiveTo: 0,
    taxableAMount: 0,
GSTRate: '',manualGSTFlag:0,
    taxability: { label: "", value: "" },
    manualDiscount: false,
      manualCess: 0,cessType:'Amount',cessRate:'',
    autoCess: 0,
    autoDiscount: 0,
    IGST: 0,
    expiredtimestamp: 0,
    CGST: "0.00",
    SGST: "0.00",
    GSTCess: 0,
    netAmount: "0000",
    editable: true,
    new: true,
    reason:""
  };
  const newNonItemObj = {
    ledgerAccount: { label: "", value: "" },
    HSN: {
      label: "",
      value: "",
      companyID: "",
      hsnID: "",
      codeType: "",
      description: "",
    },
    description: "",
    taxableAMount: 0,
GSTRate: '',manualGSTFlag:0,
    taxability: { label: "", value: "" },
    manualDiscount: false,
      manualCess: 0,cessType:'Amount',cessRate:'',
    autoCess: 0,
    autoDiscount: 0,
    IGST: 0,
    expiredtimestamp: 0,
    CGST: "0.00",
    SGST: "0.00",
    GSTCess: 0,
    netAmount: 0,
    editable: true,
    new: true,
    reason:""
  };
  const [itemWiseAccordan, setItemWiseAccordan] = useState(true);
  const [nonItemWiseAccordan, setNonItemWiseAccordan] = useState(true);
  const [deleteEntriesModal, setDeleteEntriesModal] = useState(false);
  const [deleteNonEntriesModal, setDeleteNonEntriesModal] = useState(false);
  const [entryIndex, setEntryIndex] = useState("");
  const [nonEntryIndex, setNonEntryIndex] = useState("");
  const [isFocusItem, setIsFocusItem] = useState(false);
  const [isFocusNonItem, setIsFocusNonItem] = useState(false);
  const [rowIndex, setRowIndex] = useState("");
  const [nonRowIndex, setNonRowIndex] = useState("");
  const [Taxability, setTaxability] = useState();
  const [customerTaxability, setCustomerTaxability] = useState();
  const [focusTableCell, setFocusTableCell] = useState(false);
  const [taxObj, setTaxObj] = useState({ label: "", value: "" });
  const [openDropdowns, setOpenDropdowns] = useState({
    itemcode: false,
    itemName: false,
    gstRate1: false,
    taxability1: false,
    hsnCode1: false,
    unit: false,
    ledgerAccount: false,
    gstRate2: false,
    taxability2: false,
    hsnCode2: false,
  });
  const handleDropdownOpenClose = (dropdown, isOpen) => {
    setOpenDropdowns((prevState) => ({
      ...prevState,
      [dropdown]: isOpen,
    }));
  };
  const {
    data: unitList,
    isLoading: isUnitListLoading,
    isError: isUnitListError,
  } = useGetCompanyCodeTranslationQuery({ codetype: "UNITS" });

  useEffect(() => {
    if (!unitList) {
      setunits([]);
    } else {
      let unitsArray = [];
      unitList?.map((element) => {
        if (element.is_active === "1") {
          unitsArray.push({
            option: element.codetext,
            value: `${element.id}`,
            UQC: element?.uqc,
          });
        }
      });
      setunits(unitsArray);
    }
  }, [unitList]);
  async function getUnit(data) {
    let obj = {};
    let companyID = localStorage.getItem(
      "CognitoIdentityServiceProvider.5mlsbk8qss1ruh0sljp8fvq8nc.LastAuthUser"
    );

    let unitsArray = [];
    unitList?.map((element) => {
      if (element.is_active === "1") {
        obj[element.id] = element.codetext;
        unitsArray.push({
          option: element.codetext,
          value: `${element.id}`,
          UQC: element?.uqc,
        });
      }
    });
    setUnitsObj(obj);
    // setunits(unitsArray);
  }

  useEffect(() => {
    getUnit("UNITS");
  }, []);

  useEffect(() => {
    if (!itemValid) {
      setItemWiseAccordan(true);
    }
    if (!nonItemValid) {
      setNonItemWiseAccordan(true);
    }
  }, [itemValid, nonItemValid]);
  const tableContainerRef = useRef(null);

  const handleResetScroll = () => {
    if (tableContainerRef.current) {
      tableContainerRef.current.scrollLeft = 0;
    }
  };
  return (
    <>
      <TableContainer
        ref={tableContainerRef}
        className="custom-scrollbar"
        onScroll={() => {
          setOpenDropdowns((prev) => ({
            ...prev,
            itemcode: false,
            itemName: false,
            gstRate1: false,
            taxability1: false,
            hsnCode1: false,
            unit: false,
            ledgerAccount: false,
            gstRate2: false,
            taxability2: false,
            hsnCode2: false,
          }));
        }}
        onMouseEnter={() => {
          setFocusTableCell(true);
        }}
        onMouseLeave={() => {
          setFocusTableCell(false);
        }}
        id="EntryTable"
        sx={{
          width: "100%",
          overflow: "auto",
        }}
      >
        <Table className="focusTableCellBorder"
  sx={{
    '&.MuiTable-root': {
      borderCollapse: 'separate !important',
    }
  }}
>

          {/* <ItemTable
            itemWiseAccordan={itemWiseAccordan}
            setItemWiseAccordan={setItemWiseAccordan}
            showWarningSnackbar={showWarningSnackbar}
            setItems={setItems}
            data={data}
            setData={setData}
            setInitialState={setInitialState}
            items={items}
            itemTempRow={itemTempRow}
            setItemTempRow={setItemTempRow}
            itemEditedRow={itemEditedRow}
            setItemEditedRow={setItemEditedRow}
            setEntryIndex={setEntryIndex}
            setDeleteEntriesModal={setDeleteEntriesModal}
            setIsFocusItem={setIsFocusItem}
            isFocusItem={isFocusItem}
            setIsFocusNonItem={setIsFocusNonItem}
            isFocusNonItem={isFocusNonItem}
            rowIndex={rowIndex}
            setRowIndex={setRowIndex}
            accNames={accNames}
            companyState={companyState}
            setItemID={setItemID}
            itemID={itemID}
            itemType={itemType}
            setItemType={setItemType}
            openAddItemModal={openAddItemModal}
            setOpenAddItemModal={setOpenAddItemModal}
            Type={Type}
            invoiceEntry={invoiceEntry}
            units={units}
            setunits={setunits}
            originalInvoiceNos={originalInvoiceNos}
            unitsObj={unitsObj}
            setUnitsObj={setUnitsObj}
            partyType={partyType}
            registrationType={registrationType}
            companyData={companyData}
            setBackdropOpen={setBackdropOpen}
            viewMode={viewMode}
            gstOrCompositeRate={gstOrCompositeRate}
            compositeRate={compositeRate}
            taxabilityOpions={taxabilityOpions}
            compositeTaxability={compositeTaxability}
            taxabilityOutSideIndia={taxabilityOutSideIndia}
            customertaxabilityOpions={customertaxabilityOpions}
            Taxability={Taxability}
            setTaxability={setTaxability}
            customerTaxability={customerTaxability}
            setCustomerTaxability={setCustomerTaxability}
            handleDropdownOpenClose={(dropdown, isOpen) =>
              handleDropdownOpenClose(dropdown, isOpen)
            }
            openDropdowns={openDropdowns}
            setOpenDropdowns={setOpenDropdowns}
            tabelCellClass={classes}
            isFocusItemRow={isFocusItemRow}
            setIsFocusItemRow={setIsFocusItemRow}
            setIsNonItemFocusRow={setIsNonItemFocusRow}
            setItemValid={setItemValid}
            itemValid={itemValid}
            setNonItemValid={setNonItemValid}
            handleResetScroll={() => handleResetScroll()}
            focusTableCell={focusTableCell}
            setAccNames={setAccNames}
            setTableErrArr={setTableErrArr}

          /> */}
          <NewItemTable
            itemWiseAccordan={itemWiseAccordan}
            setItemWiseAccordan={setItemWiseAccordan}
            setItems={setItems}
            setInitItemTableDta={setInitItemTableDta}
            data={data}
            setData={setData}
            setInitialState={setInitialState}
            items={items}
            setEntryIndex={setEntryIndex}
            setDeleteEntriesModal={setDeleteEntriesModal}
            setIsFocusItem={setIsFocusItem}
            isFocusItem={isFocusItem}
            setIsFocusNonItem={setIsFocusNonItem}
            isFocusNonItem={isFocusNonItem}
            rowIndex={rowIndex}
            setRowIndex={setRowIndex}
            accNames={accNames}
            companyState={companyState}
            setItemID={setItemID}
            itemID={itemID}
            itemType={itemType}
            setItemType={setItemType}
            openAddItemModal={openAddItemModal}
            setOpenAddItemModal={setOpenAddItemModal}
            Type={Type}
            invoiceEntry={invoiceEntry}
            units={units}
            setunits={setunits}
            originalInvoiceNos={originalInvoiceNos}
            unitsObj={unitsObj}
            setUnitsObj={setUnitsObj}
            partyType={partyType}
            registrationType={registrationType}
            companyData={companyData}
            setBackdropOpen={setBackdropOpen}
            viewMode={viewMode}
            Taxability={Taxability}
            setTaxability={setTaxability}
            customerTaxability={customerTaxability}
            setCustomerTaxability={setCustomerTaxability}
            handleDropdownOpenClose={(dropdown, isOpen) =>
              handleDropdownOpenClose(dropdown, isOpen)
            }
            openDropdowns={openDropdowns}
            setOpenDropdowns={setOpenDropdowns}
            tabelCellClass={classes}
            isFocusItemRow={isFocusItemRow}
            setIsFocusItemRow={setIsFocusItemRow}
            setIsNonItemFocusRow={setIsNonItemFocusRow}
            setItemValid={setItemValid}
            itemValid={itemValid}
            setNonItemValid={setNonItemValid}
            handleResetScroll={() => handleResetScroll()}
            focusTableCell={focusTableCell}
            setAccNames={setAccNames}
            setTableErrArr={setTableErrArr}
            newItemObj={newItemObj}
            fixedTaxObj={taxObj}
            setFixedTaxObj={setTaxObj}
            itemCodes={itemCodes}
            setItemCodes={setItemCodes}
            itemNames={itemNames}
            setItemNames={setItemNames}
            params={params}
            // validTaxability={[...items, ...nonItems].some(
            //   (item) =>
            //     item?.taxability &&
            //     item?.taxability.label &&
            //     item?.taxability.label.trim() !== ""
            // )}
            invoiceLabels={invoiceLabels}
            labelNamesOfTcs={labelNamesOfTcs}
            labelNamesOfTds={labelNamesOfTds}
            nonItems={nonItems}
          />

          {Type !== "Pos" && (
            // <NonItemTable
            //   nonItems={nonItems}
            //   nonItemEditedRow={nonItemEditedRow}
            //   nonItemTempRow={nonItemTempRow}
            //   setNonItems={setNonItems}
            //   setNonItemEditedRow={setNonItemEditedRow}
            //   setNonItemTempRow={setNonItemTempRow}
            //   nonItemWiseAccordan={nonItemWiseAccordan}
            //   setNonItemWiseAccordan={setNonItemWiseAccordan}
            //   setNonEntryIndex={setNonEntryIndex}
            //   showWarningSnackbar={showWarningSnackbar}
            //   setDeleteNonEntriesModal={setDeleteNonEntriesModal}
            //   setIsFocusItem={setIsFocusItem}
            //   isFocusItem={isFocusItem}
            //   setIsFocusNonItem={setIsFocusNonItem}
            //   isFocusNonItem={isFocusNonItem}
            //   nonRowIndex={nonRowIndex}
            //   setNonRowIndex={setNonRowIndex}
            //   accNames={accNames}
            //   setAccNames={setAccNames}
            //   data={data}
            //   companyState={companyState}
            //   Type={Type}
            //   invoiceEntry={invoiceEntry}
            //   setDisplayAllAccounts={setDisplayAllAccounts}
            //   expenceAccNames={expenceAccNames}
            //   displayAllAccounts={displayAllAccounts}
            //   setExpenceAccNames={setExpenceAccNames}
            //   registrationType={registrationType}
            //   companyData={companyData}
            //   setBackdropOpen={setBackdropOpen}
            //   viewMode={viewMode}
            //   setData={setData}
            //   gstOrCompositeRate={gstOrCompositeRate}
            //   compositeRate={compositeRate}
            //   taxabilityOpions={taxabilityOpions}
            //   compositeTaxability={compositeTaxability}
            //   taxabilityOutSideIndia={taxabilityOutSideIndia}
            //   customertaxabilityOpions={customertaxabilityOpions}
            //   Taxability={Taxability}
            //   customerTaxability={customerTaxability}
            //   setCustomerTaxability={setCustomerTaxability}
            //   setTaxability={setTaxability}
            //   handleDropdownOpenClose={(dropdown, isOpen) =>
            //     handleDropdownOpenClose(dropdown, isOpen)
            //   }
            //   openDropdowns={openDropdowns}
            //   setOpenDropdowns={setOpenDropdowns}
            //   tabelCellClass={classes}
            //   isFocusNonItemRow={isFocusNonItemRow}
            //   setIsNonItemFocusRow={setIsNonItemFocusRow}
            //   setIsFocusItemRow={setIsFocusItemRow}
            //   nonItemValid={nonItemValid}
            //   setNonItemValid={setNonItemValid}
            //   setItemValid={setItemValid}
            //   partyType={partyType}
            //   handleResetScroll={() => handleResetScroll()}
            //   focusTableCell={focusTableCell}
            //   setTableErrArr={setTableErrArr}
            // />
            <NewNonItemTable
              setInitNonItemTableData={setInitNonItemTableData}
              nonItems={nonItems}
              setNonItems={setNonItems}
              nonItemWiseAccordan={nonItemWiseAccordan}
              setNonItemWiseAccordan={setNonItemWiseAccordan}
              setNonEntryIndex={setNonEntryIndex}
              setDeleteNonEntriesModal={setDeleteNonEntriesModal}
              setIsFocusItem={setIsFocusItem}
              isFocusItem={isFocusItem}
              setIsFocusNonItem={setIsFocusNonItem}
              isFocusNonItem={isFocusNonItem}
              nonRowIndex={nonRowIndex}
              setNonRowIndex={setNonRowIndex}
              accNames={accNames}
              setAccNames={setAccNames}
              data={data}
              companyState={companyState}
              Type={Type}
              invoiceEntry={invoiceEntry}
              setDisplayAllAccounts={setDisplayAllAccounts}
              expenceAccNames={expenceAccNames}
              displayAllAccounts={displayAllAccounts}
              registrationType={registrationType}
              companyData={companyData}
              setBackdropOpen={setBackdropOpen}
              viewMode={viewMode}
              setData={setData}
              Taxability={Taxability}
              customerTaxability={customerTaxability}
              setCustomerTaxability={setCustomerTaxability}
              setTaxability={setTaxability}
              handleDropdownOpenClose={(dropdown, isOpen) =>
                handleDropdownOpenClose(dropdown, isOpen)
              }
              openDropdowns={openDropdowns}
              setOpenDropdowns={setOpenDropdowns}
              tabelCellClass={classes}
              isFocusNonItemRow={isFocusNonItemRow}
              setIsNonItemFocusRow={setIsNonItemFocusRow}
              setIsFocusItemRow={setIsFocusItemRow}
              nonItemValid={nonItemValid}
              setNonItemValid={setNonItemValid}
              setItemValid={setItemValid}
              partyType={partyType}
              handleResetScroll={() => handleResetScroll()}
              focusTableCell={focusTableCell}
              setTableErrArr={setTableErrArr}
              newNonItemObj={newNonItemObj}
              fixedTaxObj={taxObj}
              setFixedTaxObj={setTaxObj}
              // validTaxability={[...items, ...nonItems].some(
              //   (item) =>
              //     item?.taxability &&
              //     item?.taxability?.label &&
              //     item?.taxability?.label.trim() !== ""
              // )}
              invoiceLabels={invoiceLabels}
              labelNamesOfTcs={labelNamesOfTcs}
              labelNamesOfTds={labelNamesOfTds}
              items={items}
              params={params}
            />
          )}
          {(nonItemWiseAccordan == true || itemWiseAccordan == true) && (
            <TotalAmountsTable
              nonItems={nonItems}
              setNonItems={setNonItems}
              setItems={setItems}
              items={items}
              setRowIndex={setRowIndex}
              rowIndex={rowIndex}
              nonRowIndex={nonRowIndex}
              setNonRowIndex={setNonRowIndex}
              totTaxAmt={totTaxAmt}
              setTotTaxAmt={setTotTaxAmt}
              totDiscount={totDiscount}
              setTotDicount={setTotDicount}
              totGSTCess={totGSTCess}
              setTotGSTCess={setTotGSTCess}
              totNetAmt={totNetAmt}
              setTotNetAmt={setTotNetAmt}
              totGST={totGST}
              setTotGST={setTotGST}
              totAmt={totAmt}
              setTotAmt={setTotAmt}
              data={data}
              setData={setData}
              setInitialState={setInitialState}
              Type={Type}
              companyData={companyData}
              registrationType={registrationType}
              tabelCellClass={classes}
              partyType={partyType}
              netAmountToPay={netAmountToPay}
              setNetAmountToPay={setNetAmountToPay}
              params={params}
            />
          )}
        </Table>
      </TableContainer>
      <DeleteEntries
        open={deleteEntriesModal}
        TableType="ItemTable"
        setEntryRows={setItems}
        setOpen={setDeleteEntriesModal}
        entryRows={items}
        entryInd={rowIndex}
        setDeletedRows={setDeletedItems}
      />
      <DeleteNonItems
        open={deleteNonEntriesModal}
        setEntryRows={setNonItems}
        setOpen={setDeleteNonEntriesModal}
        TableType={"PriceTable"}
        entryRows={nonItems}
        entryInd={nonRowIndex}
        setDeletedRows={setDeletedNonItems}
      />
    </>
  );
}

export default EntryTable;
